module.exports = __webpack_public_path__ + "static/img/dasasdasdasdaa.9f2cd64c.png";